import React from 'react';
import {
  LabeledCheckbox,
  type LabeledCheckboxData,
  type TranslateFn,
} from '../../labeled-checkbox/LabeledCheckbox';

/**
 * Rows are built by `BookDialogService.buildTermsData`, which already resolves
 * which checkboxes to show and their forced/disabled state.
 */
export type TermsCheckboxItem = LabeledCheckboxData & {
  key?: string;
};

export type TermsMode = 'payg' | 'membership';

export type TermsCheckboxGroupData = {
  mode?: TermsMode;
  translate?: TranslateFn;
  items?: TermsCheckboxItem[];
};

type Props = {
  data: TermsCheckboxGroupData;
};

function resolveItems(data: TermsCheckboxGroupData | undefined): TermsCheckboxItem[] {
  if (!data || !Array.isArray(data.items)) {
    return [];
  }
  return data.items;
}

export function TermsCheckboxGroup({ data }: Props) {
  const items = resolveItems(data);

  if (items.length === 0) {
    return null;
  }

  return (
    <div className="terms-checkbox-group">
      {items.map((item, index) => (
        <LabeledCheckbox
          key={item.key || item.checkboxId || String(index)}
          data={{
            ...item,
            translate: item.translate || data.translate,
          }}
        />
      ))}
    </div>
  );
}
